import { processMetadata } from '../util';

// finding 'modified' string date -> JS date
// TODO: Get rid of this obfuscation and just use processMetadata<api.Finding, Finding>.
export function processFinding(finding: api.Finding): Finding {
    return processMetadata<api.Finding, Finding>(finding);
}
